module.exports = __webpack_public_path__ + "youtube-icon-small-21b737fa67f252f93bed75904c5411f2.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/social-medias/youtube-icon-small.svg
// module id = 98
// module chunks = 0